import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import type { DetailedFollowUpTicket, FollowUpCall } from 'src/types/followUp';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';
import useTicketDetailQuery from 'src/components/followUp/hooks/useTicketDetailQuery';

const useFollowUpCallMutation = ({
  ticket,
}: {
  ticket?: DetailedFollowUpTicket;
}) => {
  const { refetch: refreshSelectedTicket } = useTicketDetailQuery(ticket?.id);
  const endpoint = useMemo(
    () =>
      generatePath(apiPaths.FOLLOW_UP.TICKETS.FOLLOW_UP_CALL, {
        id: ticket?.id,
      }),
    [ticket?.id],
  );
  return useMutation<any, any, FollowUpCall>({
    mutationKey: [endpoint],
    mutationFn: async (data) =>
      HttpService.put(endpoint, data, {}, true)
        .then((data) => {
          refreshSelectedTicket();
          return Promise.resolve(data.data);
        })
        .catch(({ response }) => Promise.reject(response.status)),
    onError: (error) => error,
    onSuccess: () => refreshSelectedTicket(),
  });
};

export default useFollowUpCallMutation;
